import {
    faCoins,
    faCreditCard,
    faFile,
    faFilePdf,
    faHistory,
    faPenAlt,
    faSearch,
    faUser,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import Button from "../../vapor/button";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers/store";

declare const window: any;

interface OnboardingComponentProps {
    setStep: (val: number) => void;
}

const OnboardingStep1 = (props: OnboardingComponentProps) => {
    const onboarding = useSelector((state: RootState) => state.onboarding);

    useEffect(() => {
        window?.aptrinsic?.("track", "business-information:ONBOARDING-START");
    }, []);

    return (
        <div className="bis-onboarding">
            <div className="bis-onboarding-welcome">
                <div className="bis-onboarding-welcome-title">
                    <FormattedMessage id="onboarding.title" />
                </div>
                <div>
                    <FormattedMessage id="onboarding.subtitle" />
                </div>
            </div>
            <div className="bis-onboarding-benefits">
                <div className="bis-onboarding-benefits-title">
                    <FormattedMessage id="onboarding.benefits.title" />
                </div>
                <div className="bis-onboarding-benefits-list">
                    <div className="bis-onboarding-benefits-item">
                        <div className="bis-onboarding-benefits-item-icon">
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                        <div className="bis-onboarding-benefits-item-title">
                            <FormattedMessage id="onboarding.benefits.title1" />
                        </div>
                        <div className="bis-onboarding-benefits-item-description">
                            <FormattedMessage id="onboarding.benefits.description1" />
                        </div>
                    </div>
                    <div className="bis-onboarding-benefits-item">
                        <div className="bis-onboarding-benefits-item-icon">
                            <FontAwesomeIcon icon={faCoins} />
                        </div>
                        <div className="bis-onboarding-benefits-item-title">
                            <FormattedMessage id="onboarding.benefits.title2" />
                        </div>
                        <div className="bis-onboarding-benefits-item-description">
                            <FormattedMessage id="onboarding.benefits.description2" />
                        </div>
                    </div>
                    <div className="bis-onboarding-benefits-item">
                        <div className="bis-onboarding-benefits-item-icon">
                            <FontAwesomeIcon icon={faHistory} />
                        </div>
                        <div className="bis-onboarding-benefits-item-title">
                            <FormattedMessage id="onboarding.benefits.title3" />
                        </div>
                        <div className="bis-onboarding-benefits-item-description">
                            <FormattedMessage id="onboarding.benefits.description3" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="bis-onboarding-start">
                <div className="bis-onboarding-start-note">
                    <FormattedMessage id="onboarding.copyright1" />{" "}
                    <strong>
                        <FormattedMessage id="onboarding.copyright2" />
                    </strong>
                    <FormattedMessage id="onboarding.copyright3" />
                </div>
                {!onboarding?.consent?.acceptGenericTerms && (
                    <div className="bis-onboarding-start-next">
                        <div>
                            <Button
                                size="medium"
                                width="200px"
                                onClick={() => props.setStep(2)}
                            >
                                <FormattedMessage id="onboarding.button" />
                            </Button>
                        </div>
                        <div>
                            <FormattedMessage id="onboarding.tip" />
                        </div>
                    </div>
                )}
                <div className="bis-onboarding-start-3steps">
                    {onboarding?.consent?.acceptGenericTerms ? (
                        <FormattedMessage id="onboarding.onestep" />
                    ) : (
                        <FormattedMessage id="onboarding.threesteps" />
                    )}
                </div>
                <div className="bis-onboarding-start-steps">
                    {!onboarding?.consent?.acceptGenericTerms && (
                        <div className="bis-onboarding-start-steps-step">
                            <div className="bis-onboarding-start-steps-step-icon">
                                <FontAwesomeIcon icon={faUser} />
                            </div>
                            <div className="bis-onboarding-start-steps-step-text">
                                <FormattedMessage id="onboarding.steps.step1" />
                            </div>
                        </div>
                    )}
                    <div className="bis-onboarding-start-steps-step">
                        <div className="bis-onboarding-start-steps-step-icon">
                            <FontAwesomeIcon icon={faFile} />
                        </div>
                        <div className="bis-onboarding-start-steps-step-text">
                            <FormattedMessage id="onboarding.steps.step2" />
                        </div>
                    </div>
                    {!onboarding?.consent?.acceptGenericTerms && (
                        <div className="bis-onboarding-start-steps-step">
                            <div className="bis-onboarding-start-steps-step-icon">
                                <FontAwesomeIcon icon={faPenAlt} />
                            </div>
                            <div className="bis-onboarding-start-steps-step-text">
                                <FormattedMessage id="onboarding.steps.step3" />
                            </div>
                        </div>
                    )}
                </div>
                <div className="bis-onboarding-start-next">
                    <div>
                        <Button
                            size="medium"
                            width="200px"
                            onClick={() => props.setStep(2)}
                        >
                            <FormattedMessage id="onboarding.button" />
                        </Button>
                    </div>
                    {onboarding?.consent?.acceptGenericTerms && (
                        <div>
                            <FormattedMessage id="onboarding.tip" />
                        </div>
                    )}
                </div>
            </div>
            <div className="bis-onboarding-requirements">
                <div className="bis-onboarding-requirements-title">
                    <FormattedMessage id="onboarding.requirements.title" />
                </div>
                <div className="bis-onboarding-requirements-list">
                    {!onboarding?.consent?.acceptGenericTerms && (
                        <div className="bis-onboarding-requirements-item">
                            <div className="bis-onboarding-requirements-item-icon">
                                <FontAwesomeIcon icon={faCreditCard} />
                            </div>
                            <div className="bis-onboarding-requirements-item-title">
                                <FormattedMessage id="onboarding.requirements.fiscalCode" />
                            </div>
                        </div>
                    )}
                    <div className="bis-onboarding-requirements-item">
                        <div className="bis-onboarding-requirements-item-icon">
                            <FontAwesomeIcon icon={faFilePdf} />
                        </div>
                        <div className="bis-onboarding-requirements-item-title">
                            <FormattedMessage id="onboarding.requirements.identityCard" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingStep1;
